import React, {FC, useState} from 'react';

import {CollapseFAQ, Colors, Modal, Text, zIndex} from '@optimaxdev/design-system';
import {Icon} from '@optimaxdev/icons';
import classNames from 'classnames';

import {FAQ, POPUP_ITEMS} from './constants';

import s from './cartItemTooltip.scss';

type PropsType = {textStyle?: string; onPopupOpen?: () => void};

/**
 * "Learn more" popup for the CL item in the cart with enabled subscription
 * @returns {React.ReactElement} - popup component
 */
export const CartItemPopupRedesign: FC<PropsType> = ({onPopupOpen, textStyle}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isFAQ, setIsFAQ] = useState(false);

    /**
     * Click handler for the "Learn More" button
     */
    const onButtonClick = () => {
        if (onPopupOpen) onPopupOpen();
        setIsOpen(true);
    };
    return (
        <>
            <button className={classNames(s.text, textStyle)} onClick={onButtonClick} type="button">
                Learn more.
            </button>
            <Modal
                isOpen={isOpen}
                onRequestClose={() => setIsOpen(false)}
                overlay="dark"
                zIndex={zIndex.popup}
                isAnimationEnabled
            >
                <section className={s.container}>
                    <h1 className={s.header}>Subscribe & Save</h1>
                    <div className={s.wrap}>
                        {POPUP_ITEMS.map(item => (
                            <div className={classNames(s.item, item.className)} key={item.name}>
                                <Icon
                                    className={s.icon}
                                    icon={item.icon}
                                    strokeWidth={2}
                                    width={item.iconWidth}
                                />
                                <Text className={s.text} lineHeight="150%" size="18px">
                                    {item.text}
                                </Text>
                            </div>
                        ))}
                        {!isFAQ && (
                            <p className={s.question}>
                                Have a question?{' '}
                                <button
                                    className={s.buttonFaq}
                                    onClick={() => setIsFAQ(true)}
                                    type="button"
                                >
                                    Open FAQ
                                </button>
                            </p>
                        )}
                    </div>
                    <div>{isFAQ && <CollapseFAQ collapses={FAQ} />}</div>
                    <div className={s.subsection}>
                        <Text color={Colors.gray} lineHeight="21px" size="14px">
                            * Free single-vision value package lenses included with eyeglasses
                            frames | Not eligible for premium tagged & readers frames | Free pair
                            available only with the code you received in email. Limited for 1 use
                            only | Any other lens package, prescription or upgrade, is available at
                            additional cost.
                        </Text>
                    </div>
                </section>
            </Modal>
        </>
    );
};
